import styled from "styled-components";

export const MainStyled = styled.main`
  width: 100%;
  height: 100%;
  position: relative;
  /* overflow: hidden; */

  /* margin: 0 auto; */
`;
